import React from 'react';
import styled from '@emotion/styled/macro';
import { MetricsColumnProps } from './key-metrics-framework.types';

const MetricsColumn: React.FC<MetricsColumnProps> = ({
  children,
  className,
}) => {
  if (children) {
    return (
      <div className={className} data-testid="metrics-column">
        {children}
      </div>
    );
  }
  return null;
};

const StyledMetricsColumn = styled(MetricsColumn)`
  width: 33.3%;
  height: 31.5rem;
  padding: 0 3% 0 0;
  display: flex;
  flex-direction: column;
`;

export default StyledMetricsColumn;
